import React from "react";
import TopNav from "./TopNav";
import Settings from "../settings/Settings";
import { useSettingsContext } from "../../context/SettingsContext";

interface LayoutProps {
  children: React.ReactNode;
}

const HEADER_HEIGHT = 64;

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const { isSettingsOpen } = useSettingsContext();

  return (
    <div className="flex min-h-screen w-full flex-col bg-background-default dark:bg-background-dark text-text-primary dark:text-text-primaryDark">
      <TopNav />

      <main
        className="relative flex-grow overflow-x-hidden transition-all duration-200 bg-background-default dark:bg-background-dark flex flex-col"
        style={{
          marginTop: HEADER_HEIGHT,
          paddingBottom: '60px', // Space for fixed footer
        }}
      >
        {children}
      </main>

      {isSettingsOpen && (
        <div className="fixed top-0 left-0 w-full h-full z-[200]">
          <Settings />
        </div>
      )}
    </div>
  );
};

export default Layout;
